export function useTracking() {
    const runtimeConfig = useRuntimeConfig()

    const tracking = reactive({
        timer: null as ReturnType<typeof setTimeout> | null,
        lastTrackedData: JSON.stringify(null),
    })
    const trackFiltersTimeout = (Number(process.env.WAD_FILTER_TRACKING_TIMEOUT) || 30) * 1000

    const trackEvent = async (type: string, data: Record<string, any>) => {
        const payload = {
            event_type: type,
            event_data: data,
        }

        const headers: Record<string, string> = {
            'Content-Type': 'application/json',
        }

        fetch(`${runtimeConfig.public.wadApiBaseUrl}/v2/tracking/event`, {
            method: 'POST',
            headers,
            keepalive: true,
            body: JSON.stringify(payload),
        }).catch((e) => {
            console.error(e)
        })
    }

    // debounce + track
    const trackSearch = (
        eventType: string,
        searchOptions: Record<string, any>,
        results: any[],
        triggerNow = false
    ) => {
        if (tracking.timer) {
            clearTimeout(tracking.timer)
        }

        if (triggerNow) {
            const jsonData = JSON.stringify(searchOptions)
            if (jsonData !== tracking.lastTrackedData) {
                trackEvent(eventType, {...searchOptions, results}).then(r => {
                    tracking.lastTrackedData = jsonData
                })
            }
        } else {
            tracking.timer = setTimeout(() => {
                trackSearch(eventType, searchOptions, results, true)
            }, trackFiltersTimeout)
        }
    }

    return {
        trackSearch,
        trackEvent,
    }
}
